(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vindicta-luxury-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vdp-luxury-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-vdp-slide]')];
    const dots = [...hero.querySelectorAll('[data-vdp-dot]')];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!reduceMotion) timer = window.setInterval(() => show(current + 1), 4000);
    };
    hero.querySelector('[data-vdp-prev]').addEventListener('click', () => { show(current - 1); start(); });
    hero.querySelector('[data-vdp-next]').addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.vdpDot)); start(); }));
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    show(0);
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
